import { Component } from '@angular/core';

import { SpinnerComponent } from '@xt/ui-kit';

@Component({
  selector: 'xt-portal-app-loader',
  standalone: true,
  imports: [SpinnerComponent],
  templateUrl: './app-loader.component.html',
  styleUrl: './app-loader.component.scss',
})
export class AppLoaderComponent {}
